export const getContentApiUrl = state => process.env.CONTENT_API_URL || state.config.contentApi
export const getCanonicalUrlBase = state => process.env.CANONICAL_URL_BASE || state.config.canonicalUrlBase
